import React from 'react';

class FiveOhEight extends React.Component {
    render() {
        return (
            <p className="form-text">
                <b>Note on Accessibility:</b> Persons with disabilities or using assistive&nbsp;
                technology may find parts of this page are not fully accessible. The datasets
                that&nbsp; underlie these graphics are available on the{' '}
                <a href="/seazit/resources/">Resources</a>&nbsp; tab. For assistance, email us
                (ntpwebrequest@niehs.nih.gov) or use our{' '}
                <a href="https://tools.niehs.nih.gov/webforms/index.cfm/main/formViewer/form_id/521/to/cdm">
                    contact form
                </a>
                &nbsp; and identify the content for which access is required. NIEHS has{' '}
                <a href="https://www.niehs.nih.gov/about/od/ocpl/policies/#a6581">
                    helpful information
                </a>
                &nbsp; on accessibility.
            </p>
        );
    }
}

export default FiveOhEight;



// WEBPACK FOOTER //
// ./seazit/assets/seazit/components/FiveOhEight.js